import { z } from 'zod'

export const listClaimDtoSchema = z.object({
  userId: z.string().uuid(),
  userName: z.string().nullable(),
  quantity: z.number(),
})

export type ListClaimDto = z.infer<typeof listClaimDtoSchema>

export const listItemDtoSchema = z.object({
  id: z.string().uuid(),
  planId: z.string().uuid(),
  text: z.string(),
  quantity: z.number(),
  createdById: z.string().uuid().nullable(),
  createdByName: z.string().nullable(),
  claims: z.array(listClaimDtoSchema),
  createdAt: z.string(),
  editedAt: z.string().nullable(),
})

export type ListItemDto = z.infer<typeof listItemDtoSchema>

export const addListItemInputSchema = z.object({
  text: z.string().min(1).max(200),
  quantity: z.number().int().min(1).default(1),
})

export type AddListItemInput = z.infer<typeof addListItemInputSchema>

export const updateListItemInputSchema = z
  .object({
    text: z.string().min(1).max(200).optional(),
    quantity: z.number().int().positive().optional(),
  })
  .refine((d) => d.text !== undefined || d.quantity !== undefined, {
    message: 'At least one of text or quantity must be provided',
  })

export type UpdateListItemInput = z.infer<typeof updateListItemInputSchema>

export const claimItemInputSchema = z.object({
  quantity: z.number().int().min(1).default(1),
})

export type ClaimItemInput = z.infer<typeof claimItemInputSchema>

export const listItemsResponseSchema = z.object({
  items: z.array(listItemDtoSchema),
})

export const listItemResponseSchema = z.object({
  item: listItemDtoSchema,
})

export const claimResponseSchema = z.object({
  claim: z.object({
    itemId: z.string().uuid(),
    userId: z.string().uuid(),
    quantity: z.number().int(),
  }),
})

export type ListItemsResponse = z.infer<typeof listItemsResponseSchema>
export type ListItemResponse = z.infer<typeof listItemResponseSchema>
export type ClaimResponse = z.infer<typeof claimResponseSchema>
